// Allowed file types for document uploads
export const ALLOWED_FILE_TYPES = [
  // PDF Documents
  'application/pdf',
  
  // Images
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/gif',
  'image/webp',
  'image/bmp',
  'image/tiff',
  
  // Microsoft Office Documents
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
  'application/msword', // .doc
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
  'application/vnd.ms-excel', // .xls
  'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
  'application/vnd.ms-powerpoint', // .ppt
  
  // Text Documents
  'text/plain', // .txt
  'text/rtf', // .rtf
  'application/rtf', // .rtf (alternative)
  
  // OpenDocument Formats
  'application/vnd.oasis.opendocument.text', // .odt
  'application/vnd.oasis.opendocument.spreadsheet', // .ods
  'application/vnd.oasis.opendocument.presentation', // .odp
  
  // Other Common Formats
  'text/csv', // .csv
  'application/json', // .json
  'text/html', // .html
  'application/xhtml+xml', // .xhtml
  'application/xml', // .xml
  'text/xml', // .xml (alternative)

  // Email Formats
  'message/rfc822', // .eml
  'application/vnd.ms-outlook' // .msg
];

// Maximum file size: 50MB
export const MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024; // 50MB 